import { render, staticRenderFns } from "./PricingPlans.vue?vue&type=template&id=1780b577&"
import script from "./PricingPlans.vue?vue&type=script&lang=js&"
export * from "./PricingPlans.vue?vue&type=script&lang=js&"
import style0 from "./PricingPlans.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports